// Utility function to merge class names
export function cn(...classes) {
  return classes.flat().filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
}
